import Component from 'gia/Component'
import eventbus from 'gia/eventbus';
import stage from '../components/stage'
import renderer from '../components/render'
import _each from 'lodash.foreach'
import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);

import Sketch from '../components/sketch'
import { log } from 'handlebars';


class Studio extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.html = $('html')
    this.menu = $('.menu')
    this.element = element
    this.el = $(element)
    this.index = 0


    this.ref = {
      text: null,
      text2: null,
      text3: null,
      text4: null,
      spacer1: null,
      spacer2: null,
      spacer3: null,
      screens: null
    }

  }

  mount() {


  

    let tl = gsap.timeline({
        // yes, we can add it to an entire timeline!
        scrollTrigger: {
             trigger: this.ref.spacer1,
             start: "top top+=50%", // the default values
             end: "bottom top+=50%",
             scrub: .1
        
        },
    });
    this.tl = tl
    //gsap.set(this.ref.text,{ yPercent: 50})
    tl.to(this.ref.text, {
        opacity: 1,
    
        duration: 1
    });
    tl.to(this.ref.text, {
        opacity: 1,
       
        duration: 2
    });
    tl.to(this.ref.text, {
        opacity: 0,
       
        duration: 1
    });




    let tl2 = gsap.timeline({
         // yes, we can add it to an entire timeline!
        scrollTrigger: {
            trigger: this.ref.spacer2,
            start: "top top+=50%", // the default values
            end: "bottom top+=50%",
            scrub: .1

        },
    });
    this.tl2 = tl2
   
    tl2.to(this.ref.text2, {
        opacity: 1,
        //yPercent: 25,
        duration: 1
    });
    tl2.to(this.ref.text2, {
        opacity: 1,
       // yPercent: -25,
        duration: 2
    });
    tl2.to(this.ref.text2, {
        opacity: 0,
       // yPercent: -50,
        duration: 1
    });


    




    this.anim1  = gsap.to(this.ref.text3, {
                opacity: 1,
                //yPercent: 25,
                duration: 1,
        scrollTrigger: {
            trigger: this.ref.spacer3,
            start: "top bottom", // the default values
            end: "top top+=50%",
            scrub: .1

        },
    });

   ScrollTrigger.create({
       trigger: this.ref.spacer3,
       start: "bottom top",
       id: "trigger2",

       onEnter: ({
           progress,
           direction,
           isActive
       }) => {
           this.ref.screens.classList.add("elhidden")
       },
       onLeaveBack: ({
           progress,
           direction,
           isActive
       }) => {
           this.ref.screens.classList.remove("elhidden")
       }
   });
  

  this.anim2 = gsap.to(this.ref.text4, {
              opacity: 1,
              //yPercent: 25,
              duration: 1,
        
        
        scrollTrigger: {
            trigger: this.ref.spacer3,
            start: "top top+=60%", // the default values
            end: "top top+=20%",
            scrub: .1

        },
    });


    
    

    

   


    
}






  unmount() {

    this.tl.kill()
    this.tl2.kill()
    this.anim1.kill()
    this.anim2.kill()
    ScrollTrigger.getById("trigger2").kill();


  }


}

module.exports = Studio
